const GOOD_SCORE_THRESHOLD = 4;
const FAIR_SCORE_THRESHOLD = 3;

/** Spec bands: green from 4.0, amber 3.0–3.9, red below 3.0. */
export function scoreToneClasses(score: number): string {
    if (score >= GOOD_SCORE_THRESHOLD) {
        return 'bg-success-lighter text-fg-success';
    }
    if (score >= FAIR_SCORE_THRESHOLD) {
        return 'bg-warning-lighter text-fg-warning';
    }
    return 'bg-error-lighter text-fg-error';
}
